export interface PageDraft { pageId: string; draft: string; revision: string; yjsState?: string }
const memory = new Map<string, PageDraft>()
export function discardMemoryPageDrafts(): void { memory.clear() }
export function memoryPageDrafts(): PageDraft[] { return [...memory.values()] }
const PREFIX = 'ink-page-draft-v1:'
export function storePageDraft(draft: PageDraft): void {
  memory.set(draft.pageId, draft)
  const value = JSON.stringify(draft)
  localStorage.setItem(PREFIX + draft.pageId, value)
  if (localStorage.getItem(PREFIX + draft.pageId) !== value) throw new Error('Recovery draft could not be saved')
}
export function readPageDrafts(): PageDraft[] {
  const drafts: PageDraft[] = []
  for (let index = 0; index < localStorage.length; index++) {
    const key = localStorage.key(index)
    if (!key?.startsWith(PREFIX)) continue
    try {
      const draft = JSON.parse(localStorage.getItem(key)!)
      if (typeof draft.pageId === 'string' && typeof draft.draft === 'string' && typeof draft.revision === 'string' && draft.format !== 'markdown') drafts.push(draft)
    } catch { /* Keep unreadable records for manual recovery instead of deleting them. */ }
  }
  return drafts
}
export function clearPageDraft(draft: PageDraft): void {
  if (memory.get(draft.pageId)?.revision === draft.revision) memory.delete(draft.pageId)
  const key = PREFIX + draft.pageId
  const stored = localStorage.getItem(key)
  if (stored && JSON.parse(stored).revision === draft.revision) localStorage.removeItem(key)
}

export function readPageDraft(pageId: string): PageDraft | undefined {
  const draft = memory.get(pageId)
  if (draft) return draft
  try { return readPageDrafts().find(draft => draft.pageId === pageId) }
  catch { return undefined } // An unavailable emergency store must not block the primary replica.
}

export function discardPageDraft(pageId: string): void {
  memory.delete(pageId)
  localStorage.removeItem(PREFIX + pageId)
}
